/* Florage "Unser Versprechen" — Hero-Parallax + Count-up. Failsafe-first. */
(function () {
  'use strict';
  if (window.__flPromise) return;
  window.__flPromise = true;
  var nf = new Intl.NumberFormat('de-DE');

  // Hero parallax
  var bg = document.querySelector('[data-pr-hero-bg]');
  if (bg && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var tick = function () {
      var off = Math.min(window.scrollY, 600);
      bg.style.transform = 'translateY(' + (off * 0.18) + 'px) scale(1.04)';
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  // Count-up
  function run(el) {
    var to = parseInt(el.getAttribute('data-to'), 10) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var dur = 1500, start = null, raf;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var v = Math.round(to * (1 - Math.pow(1 - p, 3)));
      el.firstChild ? (el.childNodes[0].nodeValue = nf.format(v) + suffix) : (el.textContent = nf.format(v) + suffix);
      if (p < 1) raf = requestAnimationFrame(step);
    }
    raf = requestAnimationFrame(step);
    setTimeout(function () { cancelAnimationFrame(raf); el.childNodes[0].nodeValue = nf.format(to) + suffix; }, 2600);
  }
  var nums = document.querySelectorAll('[data-countup]');
  if (nums.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.3 });
      Array.prototype.forEach.call(nums, function (n) { io.observe(n); });
    } else {
      Array.prototype.forEach.call(nums, run);
    }
  }
})();
